import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  CircularProgress,
} from '@mui/material';
import type { Community } from '../../services/communityService';
import { avatarColor, getInitials } from './chatHelpers';

interface ForwardCommunityPickerProps {
  open: boolean;
  communities: Community[];
  currentCommunityId: string;
  loading?: boolean;
  onClose: () => void;
  onSelect: (communityId: string) => void;
}

export const ForwardCommunityPicker: React.FC<ForwardCommunityPickerProps> = ({
  open,
  communities,
  currentCommunityId,
  loading = false,
  onClose,
  onSelect,
}) => {
  const targets = communities.filter((c) => c.community_id !== currentCommunityId);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ fontSize: '1rem', fontWeight: 600 }}>Forward to community</DialogTitle>
      <DialogContent sx={{ px: 0, pb: 2 }}>
        {loading ? (
          <CircularProgress size={24} sx={{ display: 'block', mx: 'auto', my: 3 }} />
        ) : targets.length === 0 ? (
          <Typography sx={{ px: 3, py: 2, color: '#9aa0a6', fontSize: '0.88rem' }}>
            You have no other communities to forward to.
          </Typography>
        ) : (
          <List disablePadding>
            {targets.map((c) => (
              <ListItemButton key={c.community_id} onClick={() => onSelect(c.community_id)}>
                <ListItemAvatar>
                  <Avatar src={c.avatar_url} sx={{ bgcolor: avatarColor(c.community_id) }}>
                    {getInitials(c.name)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={c.name} secondary={`${c.member_count} members`} />
              </ListItemButton>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};
